module.exports = __webpack_public_path__ + "static/media/SL 9.8c06cc49.mp3";